import {createApp} from 'vue'
import App from '@/App.vue'
import store from '@/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import '@/assets/style.css'

import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {
    faAngleDown,
    faAngleRight,
    faArrowDownAZ,
    faArrowsRotate,
    faBasketShopping,
    faBuilding,
    faBullhorn,
    faCaretDown,
    faCaretRight,
    faCartPlus,
    faCircleChevronRight,
    faCircleChevronDown,
    faCircleXmark,
    faClipboardList,
    faCogs,
    faCopy,
    faCow,
    faEnvelope,
    faFileInvoiceDollar,
    faFilePdf,
    faMagnifyingGlass,
    faNewspaper,
    faPrint,
    faStore,
    faTrash,
    faUserLargeSlash,
    faUserPlus,
    faUsers,
    faUserShield,
    faXmark
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faAngleDown,
    faAngleRight,
    faArrowDownAZ,
    faArrowsRotate,
    faBasketShopping,
    faBuilding,
    faBullhorn,
    faCaretDown,
    faCaretRight,
    faCartPlus,
    faCircleChevronRight,
    faCircleChevronDown,
    faCircleXmark,
    faClipboardList,
    faCogs,
    faCopy,
    faCow,
    faEnvelope,
    faFilePdf,
    faFileInvoiceDollar,
    faMagnifyingGlass,
    faNewspaper,
    faPrint,
    faStore,
    faTrash,
    faUserLargeSlash,
    faUserPlus,
    faUsers,
    faUserShield,
    faXmark
)

const ERROR_MESSAGES = {
    '400': 'There was a problem processing your request.',
    '401': 'Email address or passphrase not recognized, please try again.',
    '403': 'Sorry, you are not allowed to perform this action.',
    '404': 'API route is missing or undefined.',
    '405': 'API route method not allowed.',
    '429': 'Looks like you\'ve made too many requests to the same API in the given amount of time.',
    '500': 'A server error has occurred, please try again later.',
    '511': 'Your session has expired and you have been signed out.',
    'other': 'There was a problem with your request, please try again later.',
}

axios.defaults.baseURL = 'https://ordersapi.prairiefarms.com:443'   //** use this URL for live **
//axios.defaults.baseURL = 'http://10.0.1.241:443'                    //** use this URL for qa testing **
//axios.defaults.baseURL = 'http://0.0.0.0:443'                       //** use this URL for development **

axios.interceptors.request.use(
    request => {
        if (request.url !== 'admin/announcement/get')
            document.body.classList.add('loading-indicator')

        request.headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + store.getters.asJson
        }

        return request
    },
    error => {
        if (!error.response.data) {
            error.response = {
                statusText: ERROR_MESSAGES['other'].replace('{?message?}', error.message.trim().toLowerCase())
            }
        } else {
            error.response.statusText = ERROR_MESSAGES[error.response.status]
        }

        store.commit('logout')

        document.body.classList.remove('loading-indicator')

        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    response => {
        document.body.classList.remove('loading-indicator')

        return response
    },
    error => {
        if (!error.response.data) {
            error.response = {
                statusText: ERROR_MESSAGES['other'].replace('{?message?}', error.message.trim().toLowerCase())
            }
        } else {
            error.response.statusText = ERROR_MESSAGES[error.response.status]
        }

        store.commit('logout')

        document.body.classList.remove('loading-indicator')

        return Promise.reject(error)
    }
)

const app = createApp(App)
app.use(store)
app.use(VueAxios, axios, VueLodash, lodash)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')
